import React from "react";
import { Helmet } from "react-helmet";
import Navbar from '../components/navbar';
import TopBanner from '../components/top-banner';
import Footer from '../components/footer';
import Contact from "../components/contact-us";
import SocialMediaFixed from "../components/socialmedia-fixed";


const ContactPage = () => {

    return (
        <>
            <Helmet>
                <title>Contact MP Holidays - Get in Touch for Travel & Tour Assistance</title>
                <meta name="description" content="Have questions or need assistance with your Madhya Pradesh travel plans? Contact MP Holidays for expert guidance on tour packages, bookings, and customized itineraries." />
                <meta name="keywords" content="contact MP Holidays, MP tourism support, travel assistance Madhya Pradesh, tour package inquiries, Madhya Pradesh travel guide, holiday booking support, customer service MP Holidays" />
                <link rel="canonical" href="https://mpholidays.online/contact" />

                {/* JSON-LD structured data */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "ContactPage",
                        "name": "MP Holidays - Contact Us",
                        "url": "https://mpholidays.online/contact",
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": "+91 9319184060",
                            "contactType": "customer service",
                            "areaServed": "IN",
                            "availableLanguage": ["English", "Hindi"]
                        }
                    })}
                </script>
            </Helmet>


            <TopBanner />
            <Navbar />
            <Contact />
            <Footer />
            <SocialMediaFixed />
        </>
    );
};

export default ContactPage;
